import React, {useEffect, useState} from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Login from "./pages/Login";
import DemoAgreement from "./pages/DemoAgreement";
import Home from "./pages/Home";
import Signupv2 from "./pages/Signupv2";
import Upload from "./pages/Upload";
import ResultsHighLevel from "./pages/ResultsHighLevel";
import ContactUs from "./pages/ContactUs";
import ResultsOneBatch from "./pages/ResultsOneBatch";
import ResultsModule from "./pages/ResultsModule";
import ResultsCell from "./components/ResultsCell";
import ScrollToTopButton from "./components/ScrollToTopButton";
import EditProfile from "./pages/EditProfile";
import DisplaySettings from "./utils/globalSetting";
import ProfilePictureSettings from "./utils/profilePictureSettings"
import UploadSettings from "./utils/uploadSettings";
import { AppProvider } from "./context/AppContext";
import GlobalAlert from "./components/GlobalAlerts";
import About from "./pages/About";
import Help from "./pages/Help";
import Cursor from "./components/Cursor";
import Disclaimer from "./pages/Disclaimer";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfUse from "./pages/TermsOfUse";
import LandingPage2 from "./pages/LandingPage2";
import ForgotPassword from "./pages/ForgetPassword";
import ResetPassword from "./pages/ResetPassword";
import PendingApproval from "./pages/PendingApproval";
import AdminDashboard from "./pages/AdminDashboard";
import AdminRoute from "./components/AdminRoute";
import Unauthorized from "./pages/Unauthorized";


export default function App() {
  const [pp, setPP] = useState("");  
  const [showBatchName, setShowBatchName] = useState("");
  const [showModuleName, setShowModuleName] = useState("");
  const [batchName, setbatchName] = useState("");
  const [numRows, setNumRows] = useState(0);
  const [numCols, setNumCols] = useState(0);
  const [isDisabled, setIsDisabled] = useState(false); 

  const updateSettings = ({type, value}) => {
    if(type === "showBatchName") {
      setShowBatchName(value);
    }
    else if(type === "showModuleName") {
      setShowModuleName(value);
    }
  }

  const updateUploadSettings = ({type, value}) => {
    if(type === "batchName") {
      setbatchName(value)
    }
    else if(type === "numRows") {
      setNumRows(value);
    }
    else if(type === "numCols") {
      setNumCols(value);
    }
    else if(type === "isDisabled") {
      setIsDisabled(value);
    }
  }

  const updateProfilePictureSettings = (new_pp) => {
    setPP(new_pp);
  }

  return (
    <AppProvider>
      <BrowserRouter>
        <Cursor/>
        <ScrollToTopButton/>   
        <DisplaySettings.Provider value={{showBatchName, showModuleName, updateSettings}}>
        <ProfilePictureSettings.Provider value={{pp, updateProfilePictureSettings}}>
        <GlobalAlert />
        <Routes>
          <Route exact path="/" element={<LandingPage2 />} />
          <Route path="/login" element ={<Login/>}/>
          <Route path="/demo-agreement" element={<DemoAgreement />} />
          <Route path="/signupv2" element={<Signupv2 />} />
          <Route path="/pending-approval" element={<PendingApproval/>}/>
          <Route path="/privacy-policy" element={<PrivacyPolicy/>}/>
          <Route path="/terms-of-use" element={<TermsOfUse/>}/>
          <Route path="/contactUs" element={<ContactUs />} />
          <Route
            path="/admin"
            element={
              <AdminRoute>
                <AdminDashboard />
              </AdminRoute>
            }
          />
          {/* <Route path="/request-a-demo" element={<ScheduleDemo/>} /> */}
          <Route path="/upload" element={<UploadSettings.Provider value={{batchName, numRows, numCols, isDisabled, updateUploadSettings}} > <Upload /> </UploadSettings.Provider>} />
          <Route path="/resultsHighLevel" element={ <ResultsHighLevel/>}/>     
          <Route path="/resultsOneBatch" element={<ResultsOneBatch/>} /> 
          <Route path="/resultsModule" element={<ResultsModule/>} />
          <Route path="/resultsCell" element={<ResultsCell/>} />
          <Route path="/editProfile" element={<EditProfile/>} />
          <Route path="/forgot-password" element ={<ForgotPassword/>}/>
          <Route path="/reset-password" element ={<ResetPassword/>}/>
          <Route path="/landing" element={<Home/>} />
          <Route path="/about" element={<About/>} />
          <Route path="/help" element={<Help/>} />
          <Route path="/disclaimer" element={<Disclaimer/>} />
          <Route path="/unauthorized" element={<Unauthorized />} />
        </Routes>
        </ProfilePictureSettings.Provider>
        </DisplaySettings.Provider>      
        </BrowserRouter>
    </AppProvider>
    
  );
}